module.exports = __webpack_public_path__ + "static/media/checkbox.0b949071.svg";